import { render, staticRenderFns } from "./NavbarVertical.vue?vue&type=template&id=6664cffa&scoped=true&"
import script from "./NavbarVertical.vue?vue&type=script&lang=js&"
export * from "./NavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./NavbarVertical.vue?vue&type=style&index=0&id=6664cffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664cffa",
  null
  
)

export default component.exports